import React from 'react';
import styled from 'App/styled';
import { ActiveFilterData } from '@nykaa/listing-shared/type/filter';
import { hexToRgb } from '@nykaa/ui-components/styles/utils';
import CrossIcon from 'components/Icons/CircleCross';

const FilterPill = styled.li`
  border-radius: 9999px;
  display: flex;
  align-items: center;
  border: 1px solid ${(props) => props.theme.brandPrimary};
  padding: 6px 12px;
  margin-right: 8px;
  margin-bottom: 8px;
  background: ${({ theme }) => hexToRgb(theme.brandPrimary, 0.05)};
  .filter-value {
    color: ${(props) => props.theme.brandPrimary};
    margin-right: 8px;
    ${({ theme }) => theme.typography.bodyMedium};
  }
  .cross {
    background: transparent;
    cursor: pointer;
    border: none;
  }
  .cross-icon {
    fill: ${(props) => props.theme.brandPrimary};
  }
`;

interface PillProps {
  filter: ActiveFilterData;
  handleCross: (filter: ActiveFilterData) => void;
  idx: number;
}
const Pill = ({ handleCross, filter, idx }: PillProps) => {
  const removeFilter = () => {
    handleCross(filter);
  };
  if (!filter?.id || !filter?.name) {
    return null;
  }
  return (
    <FilterPill
      key={idx}
      role="listitem"
    >
      <span className="filter-value">{filter.name}</span>
      <button
        className="cross"
        onClick={removeFilter}
        aria-label={`Remove ${filter.name} filter`}
      >
        <CrossIcon aria-hidden="true" />
      </button>
    </FilterPill>
  );
};

export default Pill;
